// src/stores/user/user.store.ts
import { createStore } from '@stencil/store';
import { User } from './user.types';

const initialState: User = new User();

const { state } = createStore(initialState);

export const userStore = {
  state
};